import { Controller } from '@hotwired/stimulus';
import SelectionArea from '@viselect/vanilla';

export default class extends Controller {
  static values = {
    selectables: String,
    selectionStartExclusions: {
      type: String,
      default: '[data-design-element-type], .batch-action-bar, .discussion-panel, a',
    },
  };

  connect() {
    this.selection = new SelectionArea({
      selectables: [this.selectablesValue],
      startareas: ['main'],
      boundaries: ['main'],
      class: 'selection-area',
    });

    this.selection.on('beforestart', this.#prepareForSelection.bind(this));
    this.selection.on('start', this.#disableDefaultVisualSelection.bind(this));
    this.selection.on('stop', this.#enableDefaultVisualSelection.bind(this));
    this.selection.on('move', this.#updateSelection.bind(this));
  }

  disconnect() {
    this.selection.destroy();
  }

  #updateSelection(event) {
    const added = event.store.changed.added;
    const removed = event.store.changed.removed;

    added.forEach(this.#addElement);
    removed.forEach(this.#removeElement);
  }

  #prepareForSelection({ event }) {
    const allowSelection = !this.#isBlacklistedTarget(event);
    const startNewSelection = allowSelection && !this.#isCumulativeSelection(event);
    startNewSelection && this.selection.clearSelection();

    return allowSelection;
  }

  #isBlacklistedTarget(event) {
    return event.target.closest(this.selectionStartExclusionsValue);
  }

  #disableDefaultVisualSelection() {
    this.element.classList.add('disable-select');
  }

  #enableDefaultVisualSelection() {
    this.element.classList.remove('disable-select');
    this.#hasSelection && window.getSelection().removeAllRanges();
  }

  #addElement(element) {
    const checkbox = element.querySelector('input[type="checkbox"]');
    const isGhost = element.closest('.draggable-ghost');
    !isGhost && checkbox && !checkbox.checked && checkbox.click();
  }

  #removeElement(element) {
    const checkbox = element.querySelector('input[type="checkbox"]');
    checkbox?.checked && checkbox.click();
  }

  #isCumulativeSelection(event) {
    return event.shiftKey;
  }

  get #hasSelection() {
    return this.selection.getSelection().length > 0;
  }
}
